<template>
  <div>
    <slot name="default" :listings="listings" :loaded="loaded">
      <div v-for="listing in listings" :key="`listing-${listing.id}`">
        <slot
          name="listing"
          :listing="listing"
          :route="
            router.resolve({ name: 'listing', params: { slug: listing.slug } })
          "
        >
          <img :src="listing.images[0]" />
          <p>{{ listing.subtitle }}</p>
          <p>{{ listing.title }}</p>
        </slot>
      </div>
    </slot>
    <slot name="empty" v-if="loaded && listings.length == 0" />
  </div>
</template>
<script setup lang="ts">
import { useListingStore } from "@/stores/listing";
import { Listing } from "@/types";
import { onBeforeMount, onUnmounted, ref } from "vue";
import { useRouter } from "vue-router";

const props = withDefaults(defineProps<{
  state: string[]
}>(),{
  state: ['pending','active'],
});

const router = useRouter();
const GROUP = import.meta.env.VITE_LISTING_GROUP;
const listingStore = useListingStore();

const listings = ref<Listing[]>([]);
/** False until the first fetch settles, so an empty list isn't mistaken for "none". */
const loaded = ref(false);
let watchTimeout: any = null;
/** Set on unmount so a fetch that settles late cannot reschedule polling. */
let unmounted = false;

onBeforeMount(() => {
  loadListings().then(watchListings);
});

onUnmounted(() => {
  unmounted = true;
  clearTimeout(watchTimeout);
  watchTimeout = null;
});

async function loadListings() {
  return listingStore.getListings(GROUP, props.state).then((l) => {
    // A failed refresh resolves to null; keep what we have.
    listings.value = l ?? listings.value;
    loaded.value = true;
    return listings.value;
  });
}

function watchListings() {
  if (unmounted) {
    return;
  }

  watchTimeout = setTimeout(
    () => loadListings().then(watchListings), 
    10000
  );
}
</script>
